import axios from 'axios'

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})


const instanceReports = axios.create({
    baseURL: `${process.env.REACT_APP_REPORTS_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
})

const formatAuthorization = idToken => idToken + '.' + btoa(JSON.stringify({ 'id': process.env.REACT_APP_ID }))

export default { 
    management: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/inspection-report/management',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),

    approval: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/inspection-report/approval',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),

    workflow: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/inspection-report/workflow',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),

    sign: (idToken, params) => new Promise((resolve, reject) => {
        instance.post(
            '/inspection-report/sign',
            params,
            {
                headers: {
                    Authorization: formatAuthorization(idToken)
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),

    logSignature: (idToken, params) => new Promise((resolve, reject) => {
        instanceReports.post(
            '/signature',
            params,
            {
                headers: {
                    Authorization: idToken
                }
            }
        ).then(response => {
            if (response.status === 200) {
                resolve(response.data)
            }
            else {
                reject(new Error('Couldn\'t retrieve data'))
            }
        })
         .catch(error => {
            reject(error)
        })
    }),


}